export default "__VITE_ASSET__C7R3tL1g__"